export const columns = [
  {
    key: 'title',
    label: 'Title',
    minWidth: 400,
    sortable: true,
  },
  {
    key: 'status',
    label: 'Status',
    minWidth: 120,
  },
  {
    key: 'createdAt',
    label: 'Created at',
    sortable: true,
  },
];
